import { EditorState, ContentState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import React, { useState, useEffect, useRef } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { useSelector } from 'react-redux';
import { EditorToolbarOptions } from '@debbie/common/dist/constants';
import { EmailTemplateMentionSuggestions } from '@debbie/common/dist/templates';
import { Button } from '.';
const WYSIWYGEditor = (props) => {
    const editorRef = useRef(null);
    const lang = useSelector((s) => s.lang);
    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(props.html || '').contentBlocks)));
    useEffect(() => {
        var _a;
        if (props.autoFocus && editorRef && editorRef.current) {
            // @ts-ignore
            (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.focusEditor();
        }
    }, [editorRef]);
    return (React.createElement("div", null,
        React.createElement(Editor, { ref: editorRef, toolbar: { options: EditorToolbarOptions }, editorState: editorState, onEditorStateChange: (newEditorState) => {
                setEditorState(newEditorState);
            }, stripPastedStyles: true, mention: {
                separator: ' ',
                trigger: '@',
                suggestions: EmailTemplateMentionSuggestions.map((tag) => ({
                    value: lang.mentions[tag],
                    text: lang.mentions[tag],
                    url: lang.mentions[tag],
                })),
            } }),
        React.createElement("br", null),
        React.createElement(Button, { block: true, onClick: () => {
                props.onChange(draftToHtml(convertToRaw(editorState.getCurrentContent())));
            } }, lang.inputs.save)));
};
export default WYSIWYGEditor;
//# sourceMappingURL=WYSIWYGEditor.js.map